<template>
  <div class="ddr-container">
    <div class="ddr-content">
      <a href="javascript:;" class="close-button">
      <img
        height="50"
        src="~@/assets/ddr/close-button.svg"
        alt=""
        @click="onClose()"
        v-if="showClose"
      >
      </a>
      <img
        class="ddr-stack"
        src="~@/assets/ddr/ddr-stack.png"
        alt=""
      >
      <a
        href="https://bit.ly/3dRjTWA"
        class="button"
        target="_blank"
        @click="onJoinClick()"
      >
        <img
          src="~@/assets/ddr/join-beta.png"
          alt=""
        >
      </a>
    </div>
    <!-- /.ddr-content -->
  </div>
</template>

<script>
import axios from 'axios';
import { mapMutations } from "vuex";

export default {
  name: "DDR",
  components: {},
  data() {
    return {
      showClose: false
    };
  },
  mounted(){
    localStorage.setItem("isDDRShown", 1);
    setTimeout(() => {
      this.showClose = true;
    }, 5000);
  },
  methods: {
    ...mapMutations(["closeDDR"]),
    onJoinClick(){
      this.closeDDR();
    },
    onClose(){
      axios.get("https://bit.ly/3cZQUiP");
      this.closeDDR();
    }
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/common.scss";
.ddr-container {
  display: block;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, #000000 100%);
  .ddr-content {
    position: absolute;
    bottom: 0px;
    height: 500px;
    width: 100%;
    .close-button {
      position: absolute;
      right: 20px;
      top: 20px;
      @include click();
    }
    .ddr-stack {
      position: absolute;
      bottom: 0px;
      height: 398px;
      width: 1140px;
      left: 50%;
      margin-left: -570px;
    }
    .button {
      left: 50%;
      bottom: 100px;
      position: absolute;
      height: 46px;
      width: 137px;
      display: block;
      box-shadow: 0px 2px 0px #CC8B24;
      border-radius: 15px;
      margin-left: -66px;
      transition: all 0.2s;
      &:active{
        box-shadow: 0px 0px 0px #CC8B24;
        bottom: 98px;
      }
      img {
        height: 46px;
        width: 137px;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DDR.vue